export const logout = () => ({
  type: 'LOGOUT',
});
